<template>
  <div>
    <div class="single-content-title">
      <span>（{{questionTypeStr}}）{{sort}}/4000</span>
      <div class="single-content-title-right">
        <img src="../../../assets/img/single-time.png">
        <span class="single-content-title-time">{{countdown}}s</span>
      </div>
    </div>

    <Question
      :question="question"
      :questionType="questionType"
      :optional="optional"
      :sort="sort"
      :qLen="4000"
      @optionsChange="optionsChange"
    ></Question>
    <div class="single-btn">
      <div class="single-btns">
        <a href="javascript:;" @click="toAnswer">确定</a>
      </div>
    </div>

  </div>
</template>

<script>
  import {ApiGetQuestion, ApiAnswer} from '../../../net/cdjs/index.js'
  import Question from './Question.vue'
  import {getCookie} from '../../../untils/common.js'
  export default {
    data: function () {
      return {
        uid: 0,
        questionId: 0,
        code: '',
        sort: 1,
        timer: null,
        countdown: 20,
        questionType: 1,
        question: '',
        optional: [],
        next: -1,
        resultId: 0,
        score: 0,
        exitShow: false, // 退出弹窗
        alertShow: false,
        alertStr: '',
        confirmShow: false,
      }
    },
    components:{
      Question
    },
    computed: {
      questionTypeStr: function () {
         const _arr = ['', '单选题', '多选题', '判断题']
         return _arr[parseInt(this.questionType)]
      }
    },
    methods: {
      getQuestion: function () {

        const prames = {
          questionId: this.questionId,
          uid: this.uid,
          code: this.code
        }
        ApiGetQuestion(prames).then(res=>{
          // console.log('res', res)
          if (res.code == 200) {
            this.code = res.value.code
            this.$store.commit('changeCdCode', this.code)
            this.next = res.value.next
            this.optional = this.handlOption(res.value.optional)
            this.question = res.value.question
            this.questionId = res.value.questionId
            this.questionType = res.value.questionType
            this.sort = res.value.sort
          }
        }).catch(err=>{
          // console.log('err', err)
        })
      },
      toAnswer: function (isTimeOut) {

        let _arr = this.optional.filter(item=>{
          return item.checked == true
        })
        _arr = _arr.map(item=>{
          return item.option
        })
        if (_arr.length == 0 && this.countdown != 0) {
          return
        }
       clearInterval(this.timer)
        const prames = {
          questionId: this.questionId,
          uid: this.uid,
          code: this.code,
          answer: _arr.join('')
        }
        ApiAnswer(prames).then(res=>{
          if (res.code == 200) {
            // console.log('isTimeOut',isTimeOut)
            if (isTimeOut === true) {
              this.answerTimeOut(res.value)
              return
            }
            if (res.value.answerStatus) { //回答正确并且未超时
              this.answerRight(res.value)
            } else { // 回答错未超时
              this.answerErr(res.value)
            }
          }
        }).catch(err=>{
          console.log('err', err)
        })
      },
      answerErr: function (data) {
        this.resultId = data.resultId
        this.$alert('回答错误', '提示', {
          confirmButtonText: '确定',
          callback: this.toExit
        })
      },
      answerTimeOut: function (data) {
        this.resultId = data.resultId
        this.$alert('已超时', '提示', {
          confirmButtonText: '确定',
          callback: this.toExit
        })
      },
      answerRight: function (data) {
        this.resultId = data.resultId
        if (this.next == 0) {
           this.$alert('本次试题已全部答完', '提示', {
             confirmButtonText: '确定',
             callback: this.toExit(true)
           })
          return
        }
        this.score = data.score
        this.questionId = this.next
        this.countdown = 20
        this.getQuestion()
        this.setCountDown()
      },
      handlOption: function (optional) {
        const _options = JSON.parse(optional).map(item=>{
          let option = '', content = ''
          for (let name in item) {
             option = name
             content = item[name]
          }
          return {option, content, checked: false}
        })
        return _options
      },
      optionsChange: function (_options) {
        // console.log('_options',_options)
        this.optional = _options
      },
      setCountDown: function () {
        clearInterval(this.timer)
        this.timer = setInterval(()=>{
          this.countdown --
          if (this.countdown == 0) {
            clearInterval(this.timer)
            this.toAnswer(true)
          }
        },1000)
      },
      toExit: function (isSuccess) {
        clearInterval(this.timer)
        this.$emit('toScore', isSuccess, this.resultId)
      },
    },
    mounted: function () {
      const user = JSON.parse(getCookie('user'))
      this.uid = user.uid
      // console.log('user', user)
      this.getQuestion()
      this.setCountDown()
    },
    beforeDestroy() {
      clearInterval(this.timer);
    }

  }
</script>

<style scoped>
.single-content-title{
  font-size: 15px;
  line-height: 30px;
  padding: 0 16px;
  margin-top: 13px;
  overflow: hidden;
}
.single-content-title span{
  float:left;
  color: #37BB54;
  margin-left:-8px;
}
.single-content-title-right{
  float:right;
}
.single-content-title-right img{
  width: 25px;
  height: 25px;
  float: left;
  margin-right: 7px;
}
.single-content-title-right .single-content-title-time{
  float: right;
  color: #999;
  line-height: 25px;
}
.single-btn{
  width: 100%;
  margin:0 auto;
  overflow: hidden;
}
.single-btns{
  width: 320px;
  height: 40px;
  margin: 0 auto;
}
.single-btn a{
  width: 320px;
  height: 40px;
  border-radius: 20px;
  color:#fff;
  background:#37BB54;
  float: left;
  line-height: 40px;
  text-align: center;
  margin-top: 20px;
  text-decoration: none;
  font-size: 16px;
  font-weight: 400;
}
.single-btn a:hover{
  opacity: 0.9;
}
.weui-dialog .weui-dialog__hd{
  padding:0.5em 1.6em 0.5em
}
</style>



// WEBPACK FOOTER //
// src/components/Cdjs/children/single.vue